module.exports = __webpack_public_path__ + "static/img/S.d5a8a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qdzy/S.png
// module id = yUlj
// module chunks = 0